export const aiAgent = {
  head: {
    chip: "Recepción IA",
    listingLabel: "Anuncio:",
  },
  globalNote: {
    title: "Configuración global de tu cuenta",
    body: "Se aplica a <b>TODOS tus alojamientos</b>. El Agente IA atiende a quien escribe por primera vez a tu <b>número WhatsApp conectado</b> y que <b>todavía no es cliente ni tiene una reserva</b>: resuelve sus dudas y le guía hacia la reserva.",
  },
  perListingNote: {
    title: "Se configura en cada anuncio",
    body: "La emisión de facturas usa el <b>emisor de facturación</b> vinculado a cada anuncio, por eso se activa y se ajusta en la configuración de cada anuncio (no de forma global). Abre un anuncio y entra en «Emisión de facturas».",
  },
  noEmisor: {
    title: "Este anuncio no tiene emisor de facturación",
    body: "No se puede activar la emisión de facturas hasta vincular un emisor a este anuncio en <b>Mi cuenta → Facturación electrónica</b>. Cada emisor se asigna a un anuncio.",
  },
  master: {
    requiresEmisor: "Requiere un emisor de facturación",
    on: "Activado",
    off: "Desactivado",
  },
  cartelQr: {
    title: "Cartel de check-in para recepción",
    hint: "Imprímelo y déjalo en el mostrador: el huésped lo escanea, escribe su número de reserva y hace su check-in desde el móvil. Útil cuando la OTA no manda todos los datos.",
    steps: "El huésped escanea · escribe su número de reserva · completa sus datos.",
    download: "Descargar cartel (PDF)",
    downloading: "Preparando…",
    downloadError: "No se pudo preparar el cartel.",
    copy: "Copiar enlace",
    copied: "Enlace copiado",
    language: "Idioma del cartel",
    alsoEnglish: "Añadir inglés debajo",

    copyManual: "No se pudo copiar. Selecciona el enlace y cópialo a mano.",
    popupBlocked: "El navegador bloqueó la ventana. Copia el enlace y ábrelo en otra pestaña.",
    loadError: "No se pudo cargar el cartel.",
    retry: "Reintentar",  },
  checkinSchedule: {
    title: "¿Cuándo se inicia el check-in?",
    hint: "Programa cuándo el agente envía el link de check-in al huésped. Se aplica a nivel de anuncio.",
  },
  avisoCheckin: {
    title: "Avisar por correo al completar el check-in",
    hint: "Cuando el grupo termina su registro, enviamos el resumen de la reserva —titular, acompañantes y sus documentos— con la planilla firmada adjunta. Útil para portería o recepción.",
    enable: "Enviar el aviso",
    steps: "Se envía una sola vez, cuando se registra la última persona del grupo.",
    placeholder: "porteria@tualojamiento.com",
    add: "Añadir correo",
    remove: "Quitar",
    max: "Máximo {n} correos.",
    save: "Guardar",
    saving: "Guardando…",
    saved: "Aviso guardado",
    saveError: "No se pudo guardar.",
    badEmail: "«{email}» no es una dirección válida.",
    needOne: "Añade al menos un correo para activar el aviso.",
  },
  field: {
    optional: "(opcional)",
    yes: "Sí",
    no: "No",
  },
  variant: {
    nationality: "Nacionalidad",
    writingStyle: "Forma de escribir",
  },
  robot: {
    title: "Lo que sabe el agente",
  },
  pdf: {
    loaded: "Documento cargado · el agente leerá su contenido",
    remove: "Quitar",
    replace: "Reemplazar PDF",
    dropTitle: "Subir PDF o Word de la guía del alojamiento",
    dropHint: "PDF o .docx · máximo 15 MB",
  },
  payments: {
    required: "Requiere conectar una plataforma de cobro",
    connect: "Conectar plataforma de cobro →",
  },
  faq: {
    qPlaceholder: "Pregunta · Ej: ¿Hay parking?",
    aPlaceholder: "Respuesta · Ej: Sí, gratuito en la puerta.",
  },
  list: {
    remove: "Eliminar",
    add: "Añadir",
  },
  footer: {
    saved: "Guardado",
    save: "Guardar cambios",
  },
  wa: {
    online: "en línea",
    caption: "Vista previa · se actualiza con tu configuración",
    defaultName: "Recepción IA",
  },
  errors: {
    pdfType: "El archivo debe ser un PDF o un Word (.docx).",
    pdfSize: "El archivo supera los 15 MB.",
    pdfNoText: "No se pudo leer texto del documento (¿es un PDF escaneado o está vacío?). Prueba con otro o usa texto libre.",
    pdfUpload: "No se pudo subir el PDF.",
    pdfRemove: "No se pudo quitar el PDF.",
    loadConfig: "No se pudo cargar la configuración.",
    saveConfig: "No se pudo guardar. Inténtalo de nuevo.",
  },
  features: {
    general: {
      title: "Configuración General",
      subtitle: "Define la identidad y el estilo del agente. Es una configuración de CUENTA: se aplica a TODOS tus alojamientos.",
      sections: {
        identity: {
          label: "Identidad del agente",
          hint: "Cómo se presenta y con qué estilo responde.",
        },
      },
      fields: {
        agentName: {
          label: "Nombre del agente",
          placeholder: "Ej: Sofía, Recepción Loft Ámbar…",
        },
        persona: {
          label: "Personalidad",
          options: {
            amigable: "Amigable y cercana",
            profesional: "Profesional y resolutiva",
            eficiente: "Directa y eficiente",
            entusiasta: "Entusiasta y cálida",
            sereno: "Serena y tranquila",
          },
        },
        tone: {
          label: "Tono de las respuestas",
          options: {
            cercano: "Cercano",
            cordial: "Cordial",
            formal: "Formal",
            profesional: "Profesional",
          },
        },
        responseLength: {
          label: "Longitud de las respuestas",
          options: {
            brief: "Breves (1-2 frases)",
            balanced: "Equilibradas",
            detailed: "Detalladas",
          },
        },
        useEmojis: {
          label: "Usar emojis",
        },
        language: {
          label: "Idioma principal",
          options: {
            auto: "Automático (según huésped)",
            es: "Español",
            en: "Inglés",
            fr: "Francés",
            de: "Alemán",
            pt: "Portugués",
            it: "Italiano",
          },
        },
        spanishVariant: {
          label: "Forma de escribir (español)",
        },
        signature: {
          label: "Firma de cierre",
          placeholder: "Ej: — El equipo de Loft Ámbar 🏡",
        },
      },
    },
    knowledge: {
      title: "Base de conocimiento",
      subtitle: "Todo lo que el Agente IA debe saber para atender a tus huéspedes con precisión.",
      enableLabel: "El agente usa esta base de conocimiento",
      sections: {
        knowledge: {
          label: "Conocimiento del alojamiento",
          hint: "Elige cómo aportas la información que el agente usará.",
        },
        behavior: {
          label: "Comportamiento y límites",
          hint: "Marca las reglas del agente y cuándo pedir ayuda humana.",
        },
      },
      fields: {
        kbMode: {
          label: "¿Cómo quieres aportar la información?",
          options: {
            form: "Formularios",
            text: "Texto libre",
            pdf: "Subir documento",
          },
        },
        propertyType: {
          label: "Tipo de alojamiento",
          options: {
            apartment: "Apartamento",
            house: "Casa",
            villa: "Villa",
            loft: "Loft",
            room: "Habitación",
            cabin: "Cabaña",
            hotel: "Hotel",
            hostel: "Hostal",
          },
        },
        kbText: {
          label: "Información del alojamiento",
          placeholder: "Escribe o pega aquí TODO lo que el agente debe saber: WiFi y contraseña, parking, electrodomésticos, climatización, normas, recomendaciones de la zona…",
          hint: "El agente usará este texto tal cual para responder.",
        },
        kbPdf: {
          label: "Documento del alojamiento",
          hint: "Sube la guía del alojamiento en PDF o Word (.docx). El agente leerá su contenido para responder.",
        },
        description: {
          label: "Información general",
          placeholder: "Cómo funciona la calefacción y el aire, electrodomésticos, climatización, peculiaridades del alojamiento…",
          hint: "Contexto principal que el agente usará en cada respuesta.",
        },
        wifiName: {
          label: "Nombre del WiFi",
          placeholder: "MiWifi_5G",
        },
        wifiPassword: {
          label: "Contraseña del WiFi",
        },
        parkingInfo: {
          label: "Parking",
          placeholder: "Parking gratuito en la puerta / Parking de pago a 100m / Sin parking…",
        },
        amenities: {
          label: "Servicios y equipamiento",
          placeholder: "Cocina equipada, lavadora, secadora, aire acondicionado, ascensor, cuna, toallas…",
        },
        houseRules: {
          label: "Normas de la casa",
          placeholder: "No fumar, no fiestas, mascotas no permitidas, horario de silencio 22:00–08:00…",
        },
        localRecommendations: {
          label: "Recomendaciones de la zona",
          placeholder: "Restaurantes, supermercados, transporte, qué visitar cerca…",
        },
        faqs: {
          label: "Preguntas frecuentes",
          hint: "Pares de pregunta y respuesta. Puedes adjuntar imágenes o vídeos a cada uno.",
        },
        links: {
          label: "Enlaces y documentos",
          itemPlaceholder: "https://… (guía de la casa, manual, mapa)",
          hint: "Recursos externos que el agente puede consultar.",
        },
        sendAmenityPhotos: {
          label: "Enviar fotos del equipamiento y comodidades",
          hint: "Si el huésped pregunta por una comodidad que tiene fotos, el agente responde y se las envía. Si no tiene, responde solo con texto.",
        },
        customInstructions: {
          label: "Instrucciones personalizadas",
          placeholder: "Reglas específicas de tono o contenido. Ej: ofrece siempre el late checkout si preguntan por la salida.",
        },
        forbiddenTopics: {
          label: "Temas o acciones prohibidas",
          placeholder: "Ej: no des descuentos, no confirmes cambios de fechas sin aprobación, no des datos de otros huéspedes.",
        },
        escalationRules: {
          label: "Cuándo derivar a un humano",
          placeholder: "Ej: si hay una avería, una queja seria o una solicitud de reembolso, deriva al anfitrión.",
        },
        fallbackMessage: {
          label: "Mensaje cuando no sabe la respuesta",
          placeholder: "No tengo ese dato a mano, pero aviso al anfitrión y te respondemos enseguida 🙌",
        },
        humanContact: {
          label: "Contacto del anfitrión",
          placeholder: "+34 600 000 000",
        },
        supportHours: {
          label: "Horario de atención humana",
          placeholder: "Lun–Dom 09:00–21:00",
        },
      },
    },
    checkin: {
      title: "Check-in",
      enableLabel: "Gestionar el check-in automáticamente",
    },
    newBookings: {
      title: "Nuevas reservas y leads",
      subtitle: "El agente atiende a leads nuevos (gente que escribe por primera vez y quiere reservar o tiene dudas) y les envía el enlace de Reservas Directas para que completen la reserva por la web. Es una configuración de CUENTA: se aplica a todos tus alojamientos.",
      enableLabel: "Atender leads y solicitudes de reserva",
      sections: {
        businessIdentity: {
          label: "Identidad del negocio",
          hint: "Con qué nombre se presenta el agente ante quien todavía no ha reservado.",
        },
        newLeads: {
          label: "Leads nuevos · primer contacto",
          hint: "Cómo atiende a quien escribe por primera vez interesado y todavía no ha reservado.",
        },
        bookingLink: {
          label: "Enlace de reserva",
        },
      },
      fields: {
        businessName: {
          label: "Nombre comercial",
          placeholder: "Ej: Hostel Elios, Apartamentos del Puerto, Grupo Ámbar…",
          hint: "Cuando alguien que no tiene reserva pregunta quién eres, el agente responde «soy el asistente de [este nombre]». Si lo dejas vacío se presenta de forma genérica, sin decir de qué negocio es.",
        },
        leadWelcomeMessage: {
          label: "Mensaje de bienvenida a un lead nuevo",
          placeholder: "¡Hola! 👋 Soy el asistente del alojamiento. ¿Buscas fechas para una escapada o tienes alguna duda? Encantado de ayudarte 😊",
          hint: "Saludo de primer contacto cuando alguien escribe por primera vez. No se repite en mensajes siguientes.",
        },
        leadWelcomeVerbatim: {
          label: "Enviar el saludo tal cual (sin adaptarlo)",
          hint: "Activado: el agente usa tu mensaje palabra por palabra en el primer contacto. Desactivado: lo adapta al tono de la conversación.",
        },
        answerKbForLeads: {
          label: "Responder dudas aunque aún no haya reservado",
          hint: "El agente responde sus preguntas generales con la base de conocimiento —aunque todavía no sea huésped—, además de poder pasarle el enlace de reserva.",
        },
        proactiveOffer: {
          label: "Sugerir reservar de forma proactiva",
          hint: "Aunque el lead pregunte por otras cosas, el agente le anima a reservar y le pasa el enlace cuando es oportuno, sin presionar.",
        },
        offerMessage: {
          label: "Mensaje al ofrecer reservar",
          placeholder: "¡Claro! Puedes reservar directamente desde aquí 👇 Te paso el enlace para que elijas fechas.",
          hint: "El tono que usa el agente al ofrecer la reserva. El enlace lo añade el agente automáticamente.",
        },
      },
    },
    earlyAccess: {
      title: "Gestión de horas de llegadas",
      subtitle: "El agente gestiona las solicitudes de entrada anticipada: registra la hora de llegada que pide el huésped y la atiende según tus reglas.",
      enableLabel: "Gestionar las horas de llegada",
      sections: {
        request: {
          label: "Gestión de la solicitud",
          hint: "Cómo responde el agente según la hora pedida. Si los desactivas, la solicitud queda pendiente para que tú elijas (Aprobar / Aprobar otra hora / Priorizar / Rechazar).",
        },
      },
      fields: {
        autoTentativeEarly: {
          label: "Responder «sujeto a disponibilidad» si es antes del check-in",
          hint: "El agente informa al huésped de que lo intentaréis; queda pendiente de tu confirmación.",
        },
        autoApproveLate: {
          label: "Aprobar automáticamente si es después del check-in",
          hint: "Una llegada dentro del horario normal se confirma sola.",
        },
      },
    },
    lateCheckout: {
      title: "Late checkout",
      subtitle: "El agente gestiona las solicitudes de salida tardía: valida la hora, cotiza el precio y registra la petición.",
      enableLabel: "Gestionar Late checkout",
      sections: {
        availability: {
          label: "Disponibilidad y horario",
        },
        extraPrice: {
          label: "Precio de las horas extra",
          hint: "Sólo se cobra el tramo posterior a las horas de cortesía.",
        },
        messages: {
          label: "Mensajes",
        },
      },
      fields: {
        standardCheckout: {
          label: "Hora de salida estándar",
        },
        courtesyHours: {
          label: "Horas de cortesía (gratis)",
          unit: "h",
          hint: "Horas tras la salida estándar que NO se cobran nunca.",
        },
        latestTime: {
          label: "Hora máxima de salida",
          hint: "Tope absoluto. Más allá de la cortesía, las horas extra se cobran.",
        },
        subjectToAvailability: {
          label: "Sujeto a disponibilidad",
          hint: "Las horas extra sólo se ofrecen si no entra otra reserva ese día.",
        },
        autoConfirm: {
          label: "Confirmar automáticamente si el huésped acepta",
          hint: "Sólo aplica a horas sin coste.",
        },
        pricingModel: {
          label: "Modelo de precio",
          options: {
            fixed: "Precio fijo",
            perHour: "Por hora extra",
          },
        },
        price: {
          label: "Importe",
          hint: "Precio fijo, o tarifa por cada hora extra fuera de la cortesía.",
        },
        freeIfAvailable: {
          label: "Gratis si no hay entrada el mismo día",
          hint: "Si ese día está libre, las horas extra tampoco se cobran.",
        },
        paymentMethods: {
          label: "Métodos de pago de las horas extra",
          options: {
            online: "Pago online (Stripe) — el agente envía un enlace",
            cash: "Efectivo a la salida",
          },
          hint: "Puedes ofrecer uno o ambos. El agente lo indicará al huésped.",
        },
        offerMessage: {
          label: "Mensaje de oferta",
          placeholder: "¿Necesitas más tiempo? Te ofrecemos salida hasta las 13:00.",
        },
        confirmationMessage: {
          label: "Mensaje de confirmación",
          placeholder: "¡Hecho! Tienes salida tardía confirmada. Disfruta esas horas extra 🙌",
        },
      },
    },
    invoicing: {
      title: "Emisión de facturas",
      subtitle: "El agente envía al huésped un enlace para que complete sus datos fiscales y descargue su factura electrónica, usando el emisor de facturación vinculado a este alojamiento.",
      enableLabel: "Gestionar solicitudes de facturas",
      sections: {
        whenSend: {
          label: "¿Cuándo se envía el enlace de la factura?",
          hint: "Elige cómo llega el enlace al huésped. Debajo aparecen las opciones del modo que elijas.",
        },
        requirements: {
          label: "Requisitos para enviarla al momento",
          hint: "El agente solo entrega el enlace a huéspedes que ya han completado el check-in y tienen el pago de la reserva completado; al rellenar sus datos, la factura se emite y se descarga al instante. En reservas de OTA (Booking/Airbnb) la factura solo puede recibirse una vez el servicio ha comenzado (la estancia ha empezado) y el pago está completado.",
        },
        manualReview: {
          label: "Revisión manual",
          hint: "Solo se registra la petición del huésped y queda pendiente en «Facturas pendientes de envío» para que la emitas tú manualmente. No se genera ninguna factura automáticamente, y no importa cuándo la pida ni si la reserva está pagada (la revisas tú).",
        },
        fiscalData: {
          label: "Datos fiscales del emisor",
          hint: "Los datos fiscales (razón social, NIF, serie, IVA, Verifactu) NO se configuran aquí: se toman del emisor de facturación vinculado a este alojamiento en Mi cuenta → Facturación electrónica.",
        },
        sendToGuest: {
          label: "Envío al huésped",
        },
      },
      modes: {
        after_checkout: {
          label: "Solo si la pide",
          desc: "El conserje IA responde cuando el huésped pide su factura.",
        },
        always_after_checkout: {
          label: "Siempre, al terminar la estancia",
          desc: "A todos los que hayan completado el check-in, la pidan o no. Recomendado.",
        },
      },
      cards: {
        on_request: {
          label: "En cuanto la pida",
          desc: "Le llega el enlace al momento, si cumple los requisitos.",
        },
        after_checkout: {
          label: "Al terminar su estancia",
          desc: "Se guarda la petición y el enlace le llega tras el check-out.",
        },
        manual: {
          label: "Solo registrarla",
          desc: "Queda pendiente y la emites tú a mano.",
        },
      },
      fields: {
        autoIssueIfNotSubmitted: {
          label: "Emitir la factura aunque no rellene el formulario",
          hint: "Se emite con los datos de su check-in y se le envía el PDF por correo y por WhatsApp. Una factura emitida no se puede editar.",
        },
        autoIssueAfterHours: {
          label: "Cuánto esperar antes de emitirla",
          options: {
            h24: "24 horas tras enviarle el enlace",
            h48: "48 horas tras enviarle el enlace",
            h72: "72 horas tras enviarle el enlace",
          },
        },
        manualSendLink: {
          label: "Enviar al huésped el enlace para completar sus datos fiscales",
          hint: "Si lo activas, el agente envía el enlace para que el huésped adelante sus datos. La factura se emite igualmente de forma manual.",
        },
        sendToGuest: {
          label: "Enviar el enlace al huésped por",
          options: {
            email: "Email",
            whatsapp: "WhatsApp",
          },
        },
      },
    },
    extendStay: {
      title: "Alargar estancia",
      subtitle: "El agente gestiona solicitudes para añadir noches: valida disponibilidad, cotiza el precio y registra la petición.",
      enableLabel: "Permitir solicitudes para alargar la estancia",
      sections: {
        availability: {
          label: "Disponibilidad",
          hint: "El máximo de noches lo marca automáticamente la siguiente reserva del calendario.",
        },
        price: {
          label: "Precio",
        },
        messages: {
          label: "Mensajes",
        },
      },
      fields: {
        autoConfirm: {
          label: "Alargar la reserva automáticamente al confirmar",
          hint: "Si lo desactivas, queda como solicitud para que la apruebes tú.",
        },
        useListingRate: {
          label: "Usar la tarifa por noche del anuncio",
          hint: "Calcula la tarifa a partir del precio de la reserva.",
        },
        pricePerNight: {
          label: "Precio por noche adicional",
          hint: "Solo si no usas la tarifa del anuncio.",
        },
        paymentMethods: {
          label: "Métodos de pago de las noches extra",
          options: {
            online: "Pago online (Stripe) — el agente envía un enlace",
            cash: "Efectivo",
          },
        },
        offerMessage: {
          label: "Mensaje de oferta",
          placeholder: "¿Quieres quedarte más tiempo? Puedo añadir noches a tu reserva sujeto a disponibilidad.",
        },
        confirmationMessage: {
          label: "Mensaje de confirmación",
          placeholder: "¡Genial! He registrado las noches extra. Te confirmamos en cuanto se complete el pago 🙌",
        },
      },
    },
  },
  preview: {
    common: {
      noCost: "sin coste",
      subjectToAvailability: " Sujeto a disponibilidad.",
    },
    default: "¡Hola! ¿En qué puedo ayudarte? 😊",
    knowledge: {
      guestWifi: "¿Cuál es la contraseña del WiFi? 📶",
      wifiAnswer: "¡Claro! La red WiFi es *{name}* y la contraseña es *{pass}*. ¡Disfruta! 😊",
      wifiNameFallback: "la del alojamiento",
      wifiPassFallback: "••••••",
      genericAnswer: "¡Claro! Te paso ahora mismo toda la información que necesites del alojamiento 😊",
    },
    checkin: {
      propFallback: "tu alojamiento",
      welcome: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{prop}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{prop}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
      ok: "Ok",
      chooseLang: "Elige tu idioma · Choose your language",
      langEs: "Español",
      langEn: "English",
      linkMsg: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎\n\n{link}",
    },
    newBookings: {
      offerDefault: "¡Claro! 😊 Puedes reservar directamente desde aquí. Te paso el enlace para elegir fechas:",
      whoAsk: "¿Con quién hablo?",
      whoAnswer: "¡Hola! Soy el asistente de {biz} 😊 ¿En qué puedo ayudarte?",
      guestGreeting: "¡Hola! ¿Tenéis algo libre para el finde? 😊",
      howBook: "Genial, ¿cómo reservo?",
      linkLine: "{offer}\n\n🔗 Reserva aquí: {link}",
    },
    earlyAccess: {
      guestAsk: "¿Podría entrar antes? Llego sobre las 12 🙏",
      tentativeReply: "Tomamos nota de tu entrada anticipada a las 12:00. Haremos todo lo posible por tenerlo listo, pero depende de la salida del huésped anterior y de la limpieza. En cuanto esté disponible te avisamos 🙏",
      confirmedReply: "Hemos registrado tu entrada anticipada a las 12:00. Te confirmamos en breve 🙏",
    },
    lateCheckout: {
      courtesyPart: "Tienes {hours}h de cortesía gratis tras las {time}. ",
      costPart: "Para salir hasta las {time} hay un coste de {price}{perHour}.",
      perHourSuffix: " por hora extra",
      payBoth: " Puedes pagarlo online o en efectivo a la salida.",
      payCash: " El pago es en efectivo a la salida.",
      guestAsk: "¿Puedo salir más tarde mañana? 😅",
      guestConfirm: "Vale, confirmo 👍",
      cashExtra: " (o en efectivo a la salida)",
      confirmPayDefault: "¡Hecho! Para confirmar, completa el pago{extra}:",
      payLabel: "Pagar {price}",
      confirmCashDefault: "¡Hecho! Tu salida queda confirmada. El pago de {price} es en efectivo a la salida. 😊",
    },
    invoicing: {
      guestAsk: "¿Me puedes enviar la factura? 🧾",
      linkMsg: "Hola! 👋\n\nAquí tienes tu link para generar y descargar tu factura electrónica:\n{link}\n\nPuedes volver a este enlace cuando lo necesites para acceder a ella.",
      thanks: "¡Gracias por tu estancia! 🙌 Si necesitas tu factura, aquí tienes el enlace 👇",
      autoIssueNote: "_({hours} h después, si no ha completado sus datos)_\n\nTe hemos emitido la factura con los datos de tu check-in y te la hemos enviado por correo. 📩",
      manualLinkMsg: "Hola! 👋\n\nAquí tienes el enlace para completar tus datos fiscales:\n{link}\n\nRevisaremos tu solicitud y te emitiremos la factura manualmente. 😊",
      manualRegistered: "¡Hola! 👋 He registrado tu solicitud de factura. La revisaremos y te la emitiremos manualmente lo antes posible. ¡Gracias! 😊",
    },
    extendStay: {
      guestAsk: "¿Puedo quedarme una noche más? 🌙",
      guestConfirm: "Sí, una noche más 👍",
      rateListing: "a la tarifa de tu reserva",
      ratePerNight: "por {price}/noche",
      nightSingular: "noche",
      nightPlural: "noches",
      offerDefault: "¡Claro! Puedo añadir hasta {max} {nights} {rate}.{avail}",
      cashExtra: " (o en efectivo)",
      confirmPayDefault: "¡Perfecto! Para confirmar la noche extra, completa el pago{extra}:",
      payLabel: "Pagar noche extra",
      confirmCashDefault: "¡Perfecto! He registrado la noche extra. El pago es en efectivo y el anfitrión confirmará la ampliación. 😊",
    },
    general: {
      guestAsk: "¡Hola! ¿Con quién hablo?",
      whoWithName: "Soy {name}, tu",
      whoNoName: "Soy tu",
      answer: "¡Hola! {who} asistente de recepción. ¿En qué puedo ayudarte?{emo}",
    },
  },
  nationalities: {
    auto: "Automática (según huésped)",
    latam: "Latinoamérica (neutro)",
    countries: {
      ES: "España",
      MX: "México",
      CO: "Colombia",
      AR: "Argentina",
      CL: "Chile",
      PE: "Perú",
      VE: "Venezuela",
      EC: "Ecuador",
      UY: "Uruguay",
      PY: "Paraguay",
      BO: "Bolivia",
      CR: "Costa Rica",
      PA: "Panamá",
      GT: "Guatemala",
      DO: "Rep. Dominicana",
      PR: "Puerto Rico",
      CU: "Cuba",
      FR: "Francia",
      PT: "Portugal",
      BR: "Brasil",
      US: "Estados Unidos",
      IT: "Italia",
      BE: "Bélgica",
      MA: "Marruecos",
      NL: "Países Bajos",
      CH: "Suiza",
    },
    styles: {
      latamNeutral: "Neutro latinoamericano",
      esES: "Estándar — tú · «vale», «genial»",
      esMX: "Estándar — «con gusto», «estacionamiento»",
      esCO: "General — usted · «con gusto»",
      esCOpaisa: "Paisa (Medellín) — «pues», «hágale»",
      esCOcosta: "Costeño (Caribe) — «¡ajá!», «quihubo»",
      esCOrolo: "Rolo (Bogotá) — usted · «a la orden»",
      esCOvalle: "Valluno (Cali) — voseo · «vea pues»",
      esCOsantander: "Santandereano — directo · «de una»",
      esAR: "Voseo — «dale», «buenísimo»",
      esCL: "Cordial — «estacionamiento»",
      esPE: "Usted — andino neutro",
      esVE: "Tú — «chévere»",
      esEC: "Usted — andino neutro",
      esUY: "Voseo — «ta», «bo»",
      esPY: "Voseo — cordial",
      esBO: "Usted — andino",
      esCR: "Voseo — «pura vida»",
      esPA: "Tú — caribeño",
      esGT: "Usted — cordial",
      esDO: "Tú — caribeño",
      esPR: "Tú — caribeño",
      esCU: "Tú — caribeño",
      frFR: "Francés de Francia",
      ptPT: "Portugués de Portugal",
      ptBR: "Portugués de Brasil",
      enUS: "Inglés americano",
      itIT: "Italiano de Italia",
      frBE: "Francés (Bélgica)",
      nlBE: "Neerlandés / Flamenco (Bélgica)",
      arMA: "Árabe (Marruecos)",
      frMA: "Francés (Marruecos)",
      nlNL: "Neerlandés",
      deCH: "Alemán suizo",
      frCH: "Francés suizo",
      itCH: "Italiano suizo",
    },
  },
};
